module.exports = __webpack_public_path__ + "static/media/close.2621d37f.svg";